import request from '@/utils/request.js'

export default {
    //新增场馆步道
    add(data){
        return request({
            url: '/api/alameda/add',
            method: 'POST',
            data,
            requireLogin: true
        })
    }, 
    //查询场馆步道
    fetch(params){
        return request({
            url: '/api/alameda/fetch',
            method: 'GET',
            params
        })
    },
    //查询场馆步道列表 
    list(params){ 
        return request({
            url: '/api/alameda/list',
            method: 'GET',
            params
        })
    },
    //删除场馆步道
    remove(params){
        return request({
            url: '/api/alameda/remove',
            method: 'GET',
            params
        })
    },
    //编辑场馆步道
    update(data){
        return request({
            url: '/api/alameda/update',
            method: 'POST',
            data
        })
    }, 

}